"use client";
import { UserNav } from "./user_nav";
import LumenIcon from "./icon";

export default function Header() {
  return (
    <div className="sticky top-0 left-0 right-0 border-b bg-background/95 backdrop-blur z-20 lg:px-12 px-4 header">
      <nav className="h-14 flex items-center justify-between ">
        <LumenIcon />
        <div className="lg:flex"></div>
        <div className="flex items-center gap-2">
          <UserNav />
        </div>
      </nav>
    </div>
  );
}
